import { render, staticRenderFns } from "./pageTen.vue?vue&type=template&id=179349f0&scoped=true&"
import script from "./pageTen.vue?vue&type=script&lang=js&"
export * from "./pageTen.vue?vue&type=script&lang=js&"
import style0 from "./pageTen.vue?vue&type=style&index=0&id=179349f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179349f0",
  null
  
)

export default component.exports